import chunk from 'lodash/chunk';

// TODO - Figure out a way to test this in unit tests
async function batchUpdate(items, batchSize, action) {
  const chunks = chunk(items, batchSize);
  return chunks.reduce(async (all, batch) => {
    return [...(await all), ...(await Promise.all(batch.map(action)))];
  }, []);
}

export default batchUpdate;
